export enum RelativeTime {
  Past = 'past',
  Today = 'today',
  Tomorrow = 'tomorrow',
  ThisWeek = 'thisweek',
  NextWeek = 'nextweek',
  Future = 'future'
}
